import home from './src/home.vue'
import OneMap from './src/OneMap/OneMap.vue' //应急一张图组件
import EmergencyOperations from './src/EmergencyOperations/EmergencyOperations.vue' //应急作战指挥 
import EmergencyOperationsNew from './src/EmergencyOperationsNew/EmergencyOperations.vue' //应急作战指挥 新国标 
import Materiallist from './src/Material/Materiallist.vue'
import Materialinfo from './src/Material/Materialinfo.vue'
import MaterialInWarehouse from './src/Material/MaterialInWarehouse.vue'
import MaterialOutWarehouse from './src/Material/MaterialOutWarehouse.vue'
import MaterialWarehouselist from './src/Material/MaterialWarehouselist.vue'
import MaterialWarehouseinfo from './src/Material/MaterialWarehouseinfo.vue'
import MaterialResourcerecordlist from './src/Material/MaterialResourcerecordlist.vue'
import ResourcesTeamlist from './src/Resources/ResourcesTeamlist.vue'
import ResourcesTeaminfo from './src/Resources/ResourcesTeaminfo.vue'
import ResourcesTeamPlayerlist from './src/Resources/ResourcesTeamPlayerlist.vue'
import NewEvent from "./src/Event/NewEvent.vue"
import EventList from './src/Event/Eventlist.vue'
import ConfirmEvent from './src/Event/ConfirmEvent.vue'
import ReportEvent from './src/Event/ReportEvent.vue'
import SeeEventInfo from './src/Event/SeeEventInfo.vue'
import PersonOrganiztionlist from './src/Resources/PersonOrganiztionlist'
import PersonOrganiztioninfo from './src/Resources/PersonOrganiztioninfo'
import PlanList from './src/Plan/PlanList'
import PlanDetail from './src/Plan/PlanDetail'
import AddressbookManage from './src/Resources/AddressbookManage'
import Addrescueteamlist from './src/Resources/Addrescueteamlist'
import Addressbookinfo from './src/Resources/Addressbookinfo'
import Tranresourceslist from './src/Resources/Tranresourceslist'
import Tranresourcesinfo from './src/Resources/Tranresourcesinfo'
import Shelterlist from './src/Resources/Shelterlist'
import Shelterinfo from './src/Resources/Shelterinfo'
import Communicationresourceslist from './src/Resources/Communicationresourceslist'
import Communicationresourcesinfo from './src/Resources/Communicationresourcesinfo'
import Medicalresourceslist from './src/Resources/Medicalresourceslist'
import Medicalresourcesinfo from './src/Resources/Medicalresourcesinfo'
import PlanManage from './src/Plan/PlanManage'
import AttachList from './src/Plan/AttachList'
import TaskList from './src/Plan/TaskList'
import ResourcesTeamManage from './src/Resources/ResourcesTeamManage'
import TaskInfo from './src/Plan/TaskInfo'
import CommunicationSettingInfo from './src/Plan/CommunicationSettingInfo'
import FinishEvent from './src/Event/FinishEvent.vue'
import EmergencyIncidentList from './src/Event/EmergencyIncidentList'
import ClassicCaseView from './src/ClassicCase/ClassicCaseView'
import ClassicCaseInfo from './src/ClassicCase/ClassicCaseInfo'

let views = {
    home,
    OneMap,
    EmergencyOperations,
    EmergencyOperationsNew,
    Materiallist,
    Materialinfo,
    MaterialInWarehouse,
    MaterialOutWarehouse,
    MaterialWarehouselist,
    MaterialWarehouseinfo,
    MaterialResourcerecordlist,
    ResourcesTeamlist,
    ResourcesTeaminfo,
    ResourcesTeamPlayerlist,
    NewEvent,
    EventList,
    ConfirmEvent,
    SeeEventInfo,
    ReportEvent,
    PersonOrganiztionlist,
    PersonOrganiztioninfo,
    PlanList,
    PlanDetail,
    AddressbookManage,
    Addrescueteamlist,
    Addressbookinfo,
    Tranresourceslist,
    Tranresourcesinfo,
    Shelterlist,
    Shelterinfo,
    Communicationresourceslist,
    Communicationresourcesinfo,
    Medicalresourceslist,
    Medicalresourcesinfo,
    PlanManage,
    AttachList,
    TaskList,
    ResourcesTeamManage,
    TaskInfo,
    CommunicationSettingInfo,
    FinishEvent,
    EmergencyIncidentList,
    ClassicCaseView,
    ClassicCaseInfo
};

export default views;